import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  FailedNotificationTasksPage,
  FailedNotificationTasksParams,
  getFailedNotificationTasks,
} from 'api/highnote/notificationTasks'
import { highnoteKeys } from './keys'

export const useFailedNotificationTasks = (
  params: FailedNotificationTasksParams
) =>
  useQuery<FailedNotificationTasksPage>({
    queryKey: highnoteKeys.failedNotificationTasks(params),
    queryFn: () => getFailedNotificationTasks(params),
    placeholderData: keepPreviousData,
  })
